import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface InfoBannerProps {
  icon?: LucideIcon;
  title?: string;
  children: React.ReactNode;
  variant?: "info" | "success" | "warning" | "error";
  className?: string;
}

const variantStyles = {
  info: "border-navy-blueprint/20 bg-navy-deep/5 text-navy-deep",
  success: "border-green-200 bg-green-50 text-green-900",
  warning: "border-amber-200 bg-amber-50 text-amber-900",
  error: "border-red-200 bg-red-50 text-red-900",
};

export function InfoBanner({
  icon: Icon,
  title,
  children,
  variant = "info",
  className,
}: InfoBannerProps) {
  return (
    <div
      className={cn(
        "flex gap-3 rounded-xl border px-4 py-3 text-sm",
        variantStyles[variant],
        className,
      )}
      role={variant === "error" ? "alert" : "status"}
    >
      {Icon ? <Icon className="mt-0.5 h-4 w-4 shrink-0 opacity-70" aria-hidden /> : null}
      <div className="min-w-0">
        {title ? <p className="font-semibold">{title}</p> : null}
        <p className={cn(title && "mt-0.5", "leading-relaxed opacity-90")}>{children}</p>
      </div>
    </div>
  );
}
